import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Redirect } from 'react-router';

import { DossierRoute } from '../../pages/Dossier/Route';
import { FiltersPanel } from '../../pages/Filters';
import { HomepageRoute } from '../../pages/Homepage/HomepageRoute';
import { MessageTemplateRoute } from '../../pages/MessageTemplate/Route';
import { PipelineRoute } from '../../pages/Pipeline/Route';
import { TodoRoute } from '../../pages/Todo/Route';

import { BrowserHistoryReplace } from './BrowserHistoryReplace';

export const DEFAULT_VIEW_ROUTE = '/homepage';

export const Routes = (): JSX.Element => (
    <React.Fragment>
        <React.Fragment>
            <Route path="/todo" component={FiltersPanel} />
            <Route path="/process" component={FiltersPanel} />
            <Route path="/homepage" component={FiltersPanel} />
        </React.Fragment>
        <BrowserHistoryReplace from="/" to={DEFAULT_VIEW_ROUTE} />
        <Switch>
            {HomepageRoute}
            {PipelineRoute}
            {TodoRoute}
            {MessageTemplateRoute}
            <DossierRoute />
            <Redirect to={DEFAULT_VIEW_ROUTE} />
        </Switch>
    </React.Fragment>
);
